import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitleNonFinal: {
		id: 'eoc-changeboarding.controllers.store.global.error-title-non-final',
		defaultMessage: 'Couldn’t open the shifting guide',
		description: 'Error message informing the user that updating the field failed',
	},
	errorDescriptionNonFinal: {
		id: 'eoc-changeboarding.controllers.store.global.error-description-non-final',
		defaultMessage: 'Something went wrong. Reload the page and try again.',
		description: 'Error message informing the user that updating the field failed',
	},
	errorActionNonFinal: {
		id: 'eoc-changeboarding.controllers.store.global.error-action-non-final',
		defaultMessage: 'Try again',
		description: 'Action to retry open shifting guide',
	},
});
